import { Society, SocietyAffiliation } from 'types/api.types';
import { Option } from 'types/general.types';
import { Options } from 'react-select/dist/declarations/src/types';
import { SocietyOption } from './types';

export const toSocietyOptions: (societies: Society[]) => SocietyOption[] = (
  societies
) =>
  societies.map((el) => ({
    id: el.id,
    title: el.acronym,
    value: el.id,
    verification: el.verification,
  }));

export const affiliationToSocietyOption = (
  affiliation: SocietyAffiliation
): SocietyOption => ({
  id: affiliation.societyId.toString(),
  title: affiliation.acronym,
  value: affiliation.societyId.toString(),
});

export const getPreferredIdOptionLabel = (option?: Option | null) => {
  if (typeof option === 'string') {
    return option;
  }

  return !option || option?.value === null
    ? ''
    : `${option?.name} - ${option?.title}`;
};

export const defaultPreferredIdOption = ({
  value: null,
  title: 'No Default (not recommended)',
} as unknown) as Option;

export const isIdFieldOptionSelected = (
  { value }: Option,
  selectValue: Options<Option>
) => {
  const defaultOption = selectValue.length === 0 && value === null;
  const selectedOption = selectValue.some((option) => option.value === value);
  return selectedOption || defaultOption;
};
